import React from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import "../../../Dashboard/dashboard.css";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { rowStyle } from "../../../Dashboard/customStyles";
import {
  generateGrowthForecastStageDCF,
  updateGrowthForecastStageDCF
} from "../../../../store/modules/growthForecastStageDCF/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";

const SUSTAINABLE = "SUSTAINABLE"
const INTERNAL = "INTERNAL"

const GrowthForecastStageDCF = ({
  appState,
  growthForecastStageDCF,
  dispatchGenerateGrowthForecastStageDCF,
  dispatchUpdateGrowthForecastStageDCF
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateGrowthForecastStageDCF()
  }, [])
  const [selection, setSelection] = useState(SUSTAINABLE);

  // Methods
  const handleChange = (key, value) => {
    dispatchUpdateGrowthForecastStageDCF({ 
      [key]: (key === "sustainableNote" || key === "internalNote") ? value : CurrencyFormatter.unformat(value, { code: "USD" })
    })
  };

  const handleOnClickGPT = async (type) => {
    handleChange(type, "Generating...");
    let payload = "This is fundamental growth forecasts for two stage discounted cash flow. In this model, the analyst must estimate the firm’s short-term (Stage 1) growth rate. To determine an appropriate near-term growth rate for the first stage of the DCF, the analyst evaluates both the Internal Growth Rate (IGR) and Sustainable Growth Rate (SGR). These metrics, derived from the firm’s return on assets/equity and retention ratio, define the theoretical boundaries of self-financed growth. After examining these models and incorporating qualitative and peer-based assessments, the analyst selects a moderate, defensible short-term growth rate for use in valuation." +
      "\nThis part is calculation of Reinvestment Total. We get this by deducting Growth in Working Capital and Vapital Expenditures from Depreciation." +
      "\nDepreciation: " + Number(growthForecastStageDCF?.depreciation).toFixed(2) + "$" +
      "\nGrowth in Working Capital: " + Number(growthForecastStageDCF?.growthWorkingCapital).toFixed(2) + "$" +
      "\nCapital Expenditures: " + Number(growthForecastStageDCF?.capitalExpenditures).toFixed(2) + "$" +
      "\nReinvestment Total: " + Number(growthForecastStageDCF?.reinvestmentTotal).toFixed(2) + "$" +
      "\nThis part is calculation of Sustainable Growth Rate. We get this by multiplying Reinvestment Rate on NOPAT and Return on Equity." +
      "\nNet Operating Profit After Tax (NOPAT): " + Number(growthForecastStageDCF?.netOperatingProfitAfterTax).toFixed(2) + "$" +
      "\nReinvestment Rate on NOPAT: " + Number(growthForecastStageDCF?.reinvestmentRateOnNetOperatingProfitAfterTax).toFixed(2) + "%" +
      "\nReturn on Equity: " + Number(growthForecastStageDCF?.returnOnEquity).toFixed(2) + "%" +
      "\nExpected Sustainable Growth Rate: " + Number(growthForecastStageDCF?.sustainableExpectedGrowthRate).toFixed(2) + "%" +
      "\nThis part is calculation of Internal Growth Rate. We get this by multiplying Reinvestment Rate on Pre-tax Cash Flow and Return on Assets." +
      "\nPre-tax Cash Flow: " + Number(growthForecastStageDCF?.preTaxCashFlow).toFixed(2) + "$" +
      "\nReinvestment Rate on Pre-tax Cash Flow: " + Number(growthForecastStageDCF?.reinvestmentRateOnPreTaxCashFlow).toFixed(2) + "%" +
      "\nReturn on Assets: " + Number(growthForecastStageDCF?.returnOnAssets).toFixed(2) + "%" +
      "\nExpected Internal Growth Rate: " + Number(growthForecastStageDCF?.internalExpectedGrowthRate).toFixed(2) + "%" +
      "\nAs a result, Analyst Chosen two step growth rate is: " + Number(growthForecastStageDCF?.analystChosenTwoStepGrowthRate).toFixed(2) + "%" +
      "\nPlease analyze the company's situation."
    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleChange(type, note);
  }
  
  return (
    <>
      <div className="flex items-center justify-between pr-20">
        <h2 className="sectionHead">Fundamental Growth Forecasts for 2 Stage DCF</h2>
        <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
          <InputLabel id="demo-simple-select-standard-label">Forecast Method</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={selection}
            onChange={(e) => setSelection(e.target.value)}
            label="Forecast Method"
          >
            <MenuItem value={SUSTAINABLE}>Sustainable</MenuItem>
            <MenuItem value={INTERNAL}>Internal</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="dashboard-content">
        {selection == SUSTAINABLE ?
          (<>
            <div className="data-title-container">
              <div></div>

              <div className="data-title">
                <h6>{appState.companyData.name}</h6>
                <p>Sustainable Growth Forecast </p>
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Depreciation</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-depreciation"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.depreciation}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>(-) Growth in Working Capital</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-GWC"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.growthWorkingCapital}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>(-) Capital Expenditures</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-capital-expenditures"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.capitalExpenditures}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Reinvestment Total
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-reinvestment-total"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.reinvestmentTotal}
                />
              </div>
            </div>

            <div style={{ paddingTop: "35px" }}></div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Reinvestment Total</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-reinvestment-total-2"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.reinvestmentTotal}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Net Operating Profit After Tax (NOPAT)</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-nopat"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.netOperatingProfitAfterTax}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Reinvestment Rate on NOPAT
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-rate-nopat"
                  endAdornment
                  endAdornmentLabel="%"
                  value={growthForecastStageDCF?.reinvestmentRateOnNetOperatingProfitAfterTax}
                />
              </div>
            </div>

            <div style={{ paddingTop: "35px" }}></div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Return on Equity</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  id="growthforecaststagedcf-sgf-equity"
                  endAdornmentLabel="%"
                  endAdornment
                  onChange={(value) => handleChange("returnOnEquity", value)}
                  value={growthForecastStageDCF?.returnOnEquity}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Reinvestment Rate on NOPAT</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-rate-nopat-2"
                  endAdornment
                  endAdornmentLabel="%"
                  value={growthForecastStageDCF?.reinvestmentRateOnNetOperatingProfitAfterTax}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Expected Growth Rate (Absolute Number)
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-sgf-expected-growth-rate"
                  endAdornment
                  endAdornmentLabel="%"
                  value={growthForecastStageDCF?.sustainableExpectedGrowthRate}
                />
              </div>
            </div>
            <div style={{ paddingTop: "35px" }} />
            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Analyst Chosen 2 Step Growth Rate
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  endAdornment
                  endAdornmentLabel="%"
                  onChange={(value) => handleChange("analystChosenTwoStepGrowthRate", value)}
                  value={growthForecastStageDCF?.analystChosenTwoStepGrowthRate}
                />
              </div>
            </div>
            <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
              <h5 className="noteHead">
                Analyst Note&nbsp;&nbsp;&nbsp;
                <button onClick={() => handleOnClickGPT("sustainableNote")}>🤖</button>
              </h5>
              <textarea
                className="analystNote"
                rows={3}
                value={growthForecastStageDCF?.sustainableNote}
                onChange={(e) => handleChange("sustainableNote", e.target.value)}
              />
            </div>
          </>)
          :
          (<>
            <div className="data-title-container">
              <div></div>

              <div className="data-title">
                <h6>{appState.companyData.name}</h6>
                <p>Internal Growth Forecast</p>
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Depreciation</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-depreciation"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.depreciation}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>(-) Growth in Working Capital</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-GWC"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.growthWorkingCapital}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>(-) Capital Expenditures</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-capital-expenditures"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.capitalExpenditures}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Reinvestment Total
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-reinvestment-total"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.reinvestmentTotal}
                />
              </div>
            </div>

            <div style={{ paddingTop: "35px" }}></div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Reinvestment Total</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-reinvestment-total-2"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.reinvestmentTotal}
                />
              </div>
            </div>
            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Pre-Tax Cash Flow</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-nopat"
                  startAdornment
                  startAdornmentLabel="$"
                  value={growthForecastStageDCF?.preTaxCashFlow}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Reinvestment Rate on Pre-Tax Cash Flow
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-rate-nopat"
                  endAdornment
                  endAdornmentLabel="%"
                  value={growthForecastStageDCF?.reinvestmentRateOnPreTaxCashFlow}
                />
              </div>
            </div>

            <div style={{ paddingTop: "35px" }}></div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Return on Assets</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  endAdornment
                  endAdornmentLabel="%"
                  onChange={(value) => handleChange("returnOnAssets", value)}
                  value={growthForecastStageDCF?.returnOnAssets}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel>Reinvestment Rate on Pre-Tax Cash Flow</InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-rate-nopat-2"
                  endAdornmentLabel="%"
                  endAdornment
                  value={growthForecastStageDCF?.reinvestmentRateOnPreTaxCashFlow}
                />
              </div>
            </div>

            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Expected Growth Rate (Absolute Number)
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  disabled
                  size="small"
                  id="growthforecaststagedcf-igf-expected-growth-rate"
                  endAdornment
                  endAdornmentLabel="%"
                  value={growthForecastStageDCF?.internalExpectedGrowthRate}
                />
              </div>
            </div>
            <div style={{ paddingTop: "35px" }}></div>
            <div style={rowStyle.baseRow}>
              <div style={rowStyle.labelRow}>
                <InputLabel style={{ fontWeight: "bold" }}>
                  Analyst Chosen 2 Step Growth Rate
                </InputLabel>
              </div>
              <div style={rowStyle.fieldRow}>
                <BVAInput
                  size="small"
                  endAdornment
                  endAdornmentLabel="%"
                  onChange={(value) => handleChange("analystChosenTwoStepGrowthRate", value)}
                  value={growthForecastStageDCF?.analystChosenTwoStepGrowthRate}
                />
              </div>
            </div>
            {/* changed internalNote to sustainableNote to integrate two notes */}
            <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
              <h5 className="noteHead">
                Analyst Note&nbsp;&nbsp;&nbsp;
                <button onClick={() => handleOnClickGPT("sustainableNote")}>🤖</button>
              </h5>
              <textarea
                className="analystNote"
                rows={3}
                value={growthForecastStageDCF?.sustainableNote}
                onChange={(e) => handleChange("sustainableNote", e.target.value)}
              />
            </div>
          </>)
        }
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    growthForecastStageDCF: state.growthForecastStageDCF.growthForecastStageDCF,
    taxes: state.taxes,
    appState: state.appState,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateGrowthForecastStageDCF() {
    dispatch(generateGrowthForecastStageDCF())
  },

  dispatchUpdateGrowthForecastStageDCF({
   returnOnEquity,
   returnOnAssets,
   analystChosenTwoStepGrowthRate,
   sustainableNote,
    internalNote
  }) {
    dispatch(updateGrowthForecastStageDCF({
      returnOnEquity,
      returnOnAssets,
      analystChosenTwoStepGrowthRate,
      sustainableNote,
      internalNote
    }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(GrowthForecastStageDCF);
